import { use, useContext, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import Logowhite from "../../../../assets/CreditAnalyse/img/logo-white.e7860257.png";
import Secureicon from "../../../../assets/CreditAnalyse/img/security-safe-svgrepo-com.svg";
import "../../../../assets/CreditAnalyse/css/loaderOTP.scss";
import GetVisitorsParams from "../../../../Utility/GetVisitorsParams";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";

const Loader_FLP_V2 = () => {
  const [isVisible, setIsVisible] = useState(true); // State to control loader visibility
  const urlParams = new URLSearchParams(window.location.search);
  const history = useHistory();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const splitName = localStorage.getItem("split_name");

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false); // Hide loader after 3000ms
    }, 3000);

    return () => clearTimeout(timer); // Cleanup timer
  }, []);

  if (!isVisible) {
    return null; // Return nothing if loader is hidden
  }


  return (
    <>
      <GetVisitorsParams />
      <div className="loaderOTP">
        <div className="bg_preldr">
          <div className="container" style={{ marginTop: "-150px" }}>
            <div>
              <div className="brand">
                <div className="logo pt-3 text-center">
                  <a href="index.html">
                    <img src={Logowhite} height={60} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="preloader">
            <div className="box">
              <div className="logo">
                <img height={40} src={Secureicon} alt="" />
              </div>
            </div>
            <div className="box" />
            <div className="box" />
            <div className="box" />
            <div className="box" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loader_FLP_V2;
